/* eslint-disable no-underscore-dangle */
import React, {
  useEffect, useState, useMemo, useRef,
} from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import { getAllBlogs, getBlog } from 'models/blog';
import Breadcrumb from 'components/Breadcrumb';
import HeaderBackgroundBanner from 'components/HeaderBackgroundBanner';
import Layout from 'components/partials/Layout';
import { getObjectByLanguage } from 'language/helpers';
import Socials from './components/Socials';
import OthersListItem from './components/OthersListItem';

const BlogDetail = ({ t, ssgBlog }) => {
  const [blog, setBlog] = useState(ssgBlog);
  const [allBlogs, setAllBlogs] = useState();
  const blogContentRef = useRef();

  const getBlogFromApi = async () => {
    const blogFromApi = await getBlog(ssgBlog.id);
    setBlog(blogFromApi);
    if (blogContentRef?.current) {
      blogContentRef.current.innerHTML = blogFromApi.content;
    }
  };

  const getAllBlogsFromApi = async () => {
    const blogsFromApi = await getAllBlogs();
    setAllBlogs(blogsFromApi);
  };

  const otherBlogs = useMemo(() => {
    if (allBlogs) {
      const blogCategory = blog.category.map((cat) => cat.category_name.tr);
      const otherAllBlogs = _.filter(allBlogs, (mappedBlog) => {
        return (blog.id !== mappedBlog.id && mappedBlog.category && _.some(mappedBlog.category, (category) => {
          return (category && blogCategory.includes(category));
        }));
      });
      const randomBlogs = _.sampleSize(otherAllBlogs, 3);
      return randomBlogs;
    }
    return [];
  }, [blog, allBlogs]);

  useEffect(() => {
    getBlogFromApi();
  }, [ssgBlog.id]);

  useEffect(() => {
    getAllBlogsFromApi();
  }, []);

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: 'Blog',
      url: '/blog',
    },
    {
      label: getObjectByLanguage(blog.title),
      url: `/blog/${blog.id}`,
    },
  ];

  return (
    <main className="has-header">
      <HeaderBackgroundBanner />

      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3" style={{ rowGap: '1rem' }}>
          <div className="col-15 col-lg-12 col-md-12">
            <Breadcrumb links={breadcrumbs} />
          </div>
          <div className="col-15 col-lg-3 col-md-3">
            <span className="blog-detail-main-date">
              <strong>
                {moment(blog.date).format('DD MMMM YYYY, HH:mm')}
              </strong>
              {' '}
              tarihinde yayınlandı.
            </span>
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-15 col-lg-2 col-md-2" />
          <div className="col-15 col-lg-10 col-md-10">
            <p className="blog-detail-title">{`${getObjectByLanguage(blog.title)}`}</p>
            <div className="blog-content" ref={blogContentRef} />
            {
              otherBlogs.length > 0
             && (
               <>
                 <p className="h2 mt-5 mb-3">Diğer Blog Yazıları</p>
                 {
                   _.map(otherBlogs, (mappedBlog) => <OthersListItem key={mappedBlog.id} blog={mappedBlog} />)
                 }
               </>
             )
            }
          </div>
          <div className="col-15 col-lg-3 col-md-3 blog-detail-socials">
            <Socials url={`${process.env.domain}/blog/${blog.id}`} />
          </div>
        </div>
      </div>
    </main>
  );
};

BlogDetail.propTypes = {
  t: PropTypes.func,
  ssgBlog: PropTypes.object,
};

export const getStaticProps = async ({ params }) => {
  try {
    const { id } = params;
    const blog = await getBlog(id);

    return {
      props: {
        headTitle: getObjectByLanguage(blog.title),
        ssgBlog: blog,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

export const getStaticPaths = async () => {
  const blogs = await getAllBlogs();
  const paths = _.map(blogs, (blog) => {
    return {
      params: {
        id: blog.id,
      },
    };
  });

  return {
    fallback: 'blocking',
    paths,
  };
};

BlogDetail.Layout = Layout;

export default withTranslation('common')(BlogDetail);
